import { render, staticRenderFns } from "./n35-loki.vue?vue&type=template&id=050cb0ee&scoped=true"
import script from "./n35-loki.vue?vue&type=script&lang=js"
export * from "./n35-loki.vue?vue&type=script&lang=js"
import style0 from "./n35-loki.vue?vue&type=style&index=0&id=050cb0ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050cb0ee",
  null
  
)

export default component.exports